<button #button 
(click)="clicked ($event)"
class="btn btn-light  text-secondary"
[ngClass]="buttonClass"
[disabled]="disabled"
>{{ getText() }}</button>